import type React from 'react';
import { useShortcutScope, VARIANT_PICKER_SCOPE } from '@/components/shortcuts';

/**
 * Pushed only while the variant picker is open, suspending the rest of the
 * `seller` scope so no sale-screen shortcut (`F9`, `F10`, `Ctrl+Delete`, …)
 * fires underneath it; `F1` stays live. A named sibling of
 * `VariantPickerModal.tsx`, like `VoidConfirmScope` and `PaymentScope`.
 */
export const VariantPickerScope: React.FC = () => {
    useShortcutScope(VARIANT_PICKER_SCOPE);
    return null;
};
